// index.ts
export * from './icons';
export { default as defaultThumbnail } from './thumbnails/defaultThumbnail.webp';
export { default as defaultThumbnailJpg } from './thumbnails/defaultThumbnail.jpg';
export { default as dialogSupport } from './dialogs/support.webp';
export { default as quickActionLogin } from './quick-actions/quick-actions-login.png';
